import React from "react";
import { connect } from "react-redux";
import { SetDepositMemberBanksActive, GetDepositMemberBanks, SetReverseBankDefault } from '$Deposits/store/actions/DepositAction'
import { GetParamsData, bankCodeWriting } from '$Deposits/lib/LibCommonData'

class UserBankSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bankModal: false,
            activeBank: '',
        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { goAddBankInfo } = GetParamsData()

        const {
            SetDepositMemberBanksActive,
            DepositMemberBanksActive,
            DepositMemberBanks = [],
            UserBankSelect,
            MethodsActive,
            GetDepositMemberBanks,
            MemberInfo,
            SetReverseBankDefault,
        } = this.props;

        //是否显示添加按钮
        const showAddUserBank = !(MemberInfo && MemberInfo.isSingleDeposit) || false
        //RD银行栏右边文字icon
        const RD_Icon= MethodsActive.code == 'RD' && (DepositMemberBanks.length > 1 || showAddUserBank)? true : false
        //RD银行是否禁用
        const RD_Disabled = MethodsActive.code == 'RD' && MemberInfo.isSingleDeposit && DepositMemberBanks.length == 1 || false
        //RD银行是否已绑定
        const RD_isReverseDeposit = DepositMemberBanks.find((v) => { return v.isReverseDeposit == true }) || false
        return (

            <>
                <UserBankSelect
                    onChange={(data) => {
                        SetDepositMemberBanksActive(data)
                        MethodsActive.code == 'RD' && SetReverseBankDefault(data.code || '')
                    }}
                    DepositMemberBanksActive={DepositMemberBanksActive}
                    BankList={DepositMemberBanks}
                    AddBankClick={() => { goAddBankInfo((data = '') => {GetDepositMemberBanks(data)}, MethodsActive.code) }}
                    methods={MethodsActive.code || ''}
                    RD_Icon={RD_Icon}
                    RD_Disabled={RD_Disabled}
                    RD_isReverseDeposit={RD_isReverseDeposit}
                    showAddUserBank={showAddUserBank}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositMemberBanks: state.DepositMemberBanks,
    DepositMemberBanksActive: state.DepositMemberBanksActive,
    MethodsActive: state.MethodsActive,
    MemberInfo: state.MemberInfo,
});
const mapDispatchToProps = {
    SetDepositMemberBanksActive: (data = {}) => SetDepositMemberBanksActive(data),
    GetDepositMemberBanks: (data) => GetDepositMemberBanks(data),
    SetReverseBankDefault: (data = '') => SetReverseBankDefault(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(UserBankSelect);

